require('../../modules/es6.object.freeze');
module.exports = require('../../modules/$.core').Object.freeze;


/*****************
 ** WEBPACK FOOTER
 ** /Users/nw/flint/flintjs-deps/~/core-js/library/fn/object/freeze.js
 ** module id = 96
 ** module chunks = 1
 **/